export enum ProductRequestLayout {
    LIST = 'List',
    KANBAN = 'Board'
}